// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1O8sq","content":"styles_content__3Xcf5","row":"styles_row__2ULbg","footer":"styles_footer__3zy0w","phraseLength":"styles_phraseLength__3E89S"};